/*
 * A hand-drawn strike-through used to cross out the word "podcast"
 * before revealing "Hangout with Hunar". Keeps the JSX declarative.
 */
export const Scribble = ({ children, className = "" }) => (
  <span className={`scribble-wrap ${className}`}>
    {children}
    <svg viewBox="0 0 200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M4 24 C 34 8, 74 34, 108 18 S 168 32, 196 14" />
    </svg>
  </span>
);
